import {Component, Input} from '@angular/core';
import {WidgetModel} from '../../../model/widget.model';

@Component({
    selector: 'app-edi-files-widget-settings',
    templateUrl: './edi-files-widget.settings.component.html',
    styleUrl: './edi-files-widget.settings.component.scss'
})
export class AppEdiFilesWidgetSettingsComponent {
    @Input() widget: WidgetModel;
}